




















import { defineComponent, computed, toRefs, watch, ref } from '@vue/composition-api';

// 引入工具类
import { PAY_SOURCE, openTeamPayDialog } from '@/renderer/scripts/composition/dialogHandler';
import { SMH } from '@/renderer/scripts/smh';
import Dynamics from './component/Dynamics.vue';
// 动态
export default defineComponent({
  name: 'Dynamic',
  components: {
    Dynamics,
  },
  props: {
    params: {
      type: Object as () => Drawer.DynamicParams<SMH.GetSpaceDynamicData>,
      default: () => null,
    },
  },
  setup(props, context) {
    const { params } = toRefs(props);
    const spaceId = ref();
    const selectedItem = ref();
    const buttonTitle = ref();
    const buttonEvent = ref();
    const store = context.root.$store;
    const isPersonal = computed(() => store.getters.editionFlag !== 'personal');
    const handlerBuy = () => {
      openTeamPayDialog(PAY_SOURCE.DYNAMIC_DRAWER);
    };
    const methods = {
      didClickOperationButton() {
        buttonEvent.value();
      },
    };

    watch(
      params,
      val => {
        spaceId.value = params.value.spaceId;
        selectedItem.value = params.value.selectedItem;
        buttonTitle.value = params.value.buttonTitle;
        buttonEvent.value = params.value.buttonEvent;
      },
      {
        immediate: true,
      },
    );
    return {
      handlerBuy,
      isPersonal,
      spaceId,
      selectedItem,
      buttonTitle,
      methods,
    };
  },
});
